import {faker}  from "@faker-js/faker";
import { getAccounts } from "../helpers/get-accounts";
import { getOrgApp } from "../helpers/get-orgApp";

var regionCodes = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ap-south-1",
];

var randomVolumes = [2, 4, 8];

export const allSnapshots = async () => {
  let snapshots = [];
  let accounts = await getAccounts();
  let orgAppDetails = await getOrgApp();
  for (var i = 0; i < 20; i++) {
    let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
    let selectedDept = faker.helpers.arrayElement(selectedOrg.depts);
    let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);

    const RegionCode = faker.helpers.arrayElement(regionCodes);

    var snapshot = {
      AccountNumber: faker.helpers.arrayElement(accounts),
      ARN: `arn:aws::snapshot:${RegionCode}:${faker.random.alphaNumeric(15)}`,
      Tags: [],
      VolumeId: "vol-" + faker.random.alphaNumeric(15),
      RegionCode,
      State: "completed",
      VolumeSize: faker.helpers.arrayElement(randomVolumes),
      UpdatedAt: "2019-05-07T09:04:34Z",
      StartTime: "2019-05-02T09:04:34Z",
      ResourceId: "snapshot-" + faker.random.alphaNumeric(15),
      ResourceName: "MC-Snapshot-" + faker.random.alphaNumeric(3),
      IsDeleted: 0,
      Progress: "100%",
      Encrypted: faker.random.boolean(),
      OrganizationId: selectedOrg.orgId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      DepartmentId: selectedDept.deptId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
    };
    snapshot.OwnerId = snapshot.AccountNumber;
    snapshot.Description = "Created snapshot for " + snapshot.VolumeId;
    snapshots.push(snapshot);
  }
  return snapshots;
};

export const snapshotData = (snapshot) => {
  return {
    Description: snapshot.Description,
    Tags: snapshot.Description,
    Encrypted: snapshot.Encrypted ? "Encrypted" : "Not Encrypted",
    VolumeId: snapshot.VolumeId,
    State: snapshot.State,
    VolumeSize: snapshot.VolumeSize,
    StartTime: snapshot.UpdatedAt,
    Progress: snapshot.Progress,
    OwnerId: snapshot.AccountNumber,
    ResourceId: snapshot.ResourceId,
    AccountNumber: snapshot.AccountNumber,
  };
};
